import { Box, Typography } from '@mui/material';
import React from 'react';
import TwInitialsIndicator from '../TwInitialsIndicator/TwInitialsIndicator';
import './TwNameColumn.scss';

export interface TwNameColumnProps {
  name: string;
  subLabel?: string;
}

const TwNameColumn: React.FC<TwNameColumnProps> = ({ name, subLabel }): JSX.Element => {
  return (
    <div className="nameColumn__wrapper">
      <TwInitialsIndicator
        text={`${name}` || ''}
        sx={{
          backgroundColor: '#D4E2FC !important',
          color: '#5C6AF6 !important'
        }}
      />
      <Box component="span" className="nameColumn__name">
        {name ? `${name}` : ''}{' '}
        {subLabel && (
          <Typography variant="subtitle2" fontWeight="400" color="#9CA3AF" fontSize={'14px'}>
            {subLabel}
          </Typography>
        )}
      </Box>
    </div>
  );
};

export default TwNameColumn;
